import React, { useState } from "react";
import { StyledMessage } from "./Styles";

function Message({ variant, children, fixed }) {
  const [isAlertVisible, setIsAlertVisible] = useState(true);

  setTimeout(() => {
    if (!fixed) {
      setIsAlertVisible(false);
    }
  }, 4000);

  return (
    <span>
      {isAlertVisible && (
        <StyledMessage.Message variant={variant}>
          {children}
        </StyledMessage.Message>
      )}
    </span>
  );
}

export default Message;
